export default {
  primary: {
    main: '#3F4A60',
    dark: '#0A1730',
  },
  error: {
    main: '#dc3545',
  },
  text: {
    primary: '#3F4A60',
  },
  badge: {
    text: '#5F40E5',
    background: '#5F40E514',
  },
  gridLine: '#e0e0e0',
  borderColor: '#E8E8E8',
  inputBorderHover: '#3F4A60',
  button: {
    background: '#181818',
    text: '#FFFFFF',
  },
  background: {
    default: '#FFFFFF',
    paper: '#F9F9FA',
  },
  action: {
    hover: 'rgba(0, 0, 0, 0.1)',
  },
};
